module.exports = [
  "PT",
  "ES",
  "FR",
  "DE",
  "IT",
  "NL",
  "PL",
  "HU",
  "RO",
  "LV",
  "EE",
  "FI",
  "SE",
  "NO",
  "DK",
  "GB",
  "IE",
  "BE",
  "LU",
  "SI",
  "HR",
  "MT",
  "GR",
  "CY",
  "BG",
  "AT",
  "SK",
  "CZ",
  "LT",
  "AE"
];
